<template>
  <div class="flex flex-col ">
    <Header></Header>



    <main class="flex-grow">
      <NuxtPage />
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout'
}

</script>
